<template>
  <div>
    <el-affix :offset="0">
      <div class="header">
        <div class="nav-box flex">
          <div class="logo">
            <img :src="require('@/assets/5101/logo.png')" alt="" style="width: 30px;" />
          </div>
          <div class="items flex-item flex">
            <div
              class="item"
              v-for="(v, index) in navData"
              :key="v.path"
              :class="[index === nav_index ? 'on' : '']"
              @click="jumpPath(v)"
            >
              {{ v.name }}
            </div>
          </div>
          <div class="search-box flex">
            <div class="icon">
              <img :src="require('@/assets/5101/icon_0.png')" alt="" />
            </div>
            <div class="ipt">
              <input type="text" v-model="keyWord" />
            </div>
            <div class="btn" @click="handleSearch()">搜索</div>
          </div>
          <div class="login-box flex">
            <div class="icon">
              <img :src="require('@/assets/5101/icon_1.png')" alt="" />
            </div>
            <div class="name" v-if="!isLogin" @click="handleLogin()">
              请登录
            </div>
            <el-dropdown v-else>
              <div class="name">{{ userInfo.nickname }}</div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="handelUser()"
                    >用户中心</el-dropdown-item
                  >
                  <el-dropdown-item @click="loginOut()"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>
    </el-affix>
    <Login ref="login" />
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

// import { api } from "@/api";
import { ref, reactive, toRefs, watch } from "vue";

import Login from "@/components/common/Login.vue";
export default {
  name: "Header",
  components: { Login },
  setup() {
    const Router = useRouter();
    const store = useStore();
    const login = ref(null);
    let initData = reactive({
      isLogin: false,
      userInfo: "",

      conf: [],
      nav_index: 0,
      keyWord: "",
    });
    // route 判断是否是项目路由 || 其他网站链接
    let navData = [
      { path: "/", name: "达川文化云", route: true },
      // { path: "/village", query: "", name: "乡镇", route: true },
      // { path: "/video", query: "", name: "视频", route: true },
      { path: "/active", query: "", name: "活动预约", route: true },
      // { path: "/team", query: "", name: "文化社团", route: true },
      { path: "/calendar", query: "", name: "文化日历", route: true },
      { path: "/show/news", query: {id:'30a7942b76a511eda4dc0242ac140005'}, name: "app下载", route: true },
    ];
    // 处理菜单索引
    watch(
      () => Router.currentRoute.value,
      (newVal) => {
        let flag = true
        navData.forEach((item, index) => {
          if (item.path == newVal.path) {
            flag = false
            initData.nav_index = index;
          } else if (newVal.path == "/") {
            flag = false
            initData.nav_index = 0;
          }
        });
        if(flag) {
          initData.nav_index = -1
        } 
      },
      { immediate: true }
    );

    watch(
      () => store.state.userInfo,
      (newVal) => {
        initData.userInfo = newVal;
        if (newVal) {
          initData.isLogin = true;
        } else {
          initData.isLogin = false;
        }
      },
      { immediate: true, deep: true }
    );

    // 点击登录
    function handleLogin() {
      login.value.dialogVisible = true;
    }
    // 退出登录
    function loginOut() {
      initData.userInfo = "";
      localStorage.removeItem("whgUserInfo");
      store.commit("clearUserInfo");
      initData.isLogin = false;
      window.location.reload()
    }

    // 点击菜单
    function jumpPath(row, index) {
      if (row.route) {
        initData.nav_index = index;
        console.log(row)
        Router.push({
          path: row.path,
          query: row.query
        });
      } else {
        window.open(row.path);
      }
    }
    // 跳转到非菜单页
    function goPage(path, index) {
      initData.nav_index = index;
      Router.push({
        path: path,
      });
    }
    // 点击用户中心
    function handelUser() {
      if (initData.isLogin) {
        Router.push({
          path: "/user/index",
          
        });
      } else {
        ElMessage.warning("请先登录");
      }
    }
    function handleSearch() {
      if (initData.keyWord) {
        // console.log("点搜索", initData.keyWord);
        Router.push({
          path: "/search",
          query: {
            key: initData.keyWord
          }
        })
      } else {
        ElMessage.warning("请先输入关键字");
      }
    }
    return {
      ...toRefs(initData),
      navData,
      handleLogin,
      loginOut,
      jumpPath,
      goPage,
      login,
      handelUser,
      handleSearch
    };
  },
};
</script>

<style lang="less" scoped>
.header {
  background-color: white;
}
.nav-box {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  align-items: center;

  .logo {
    font-size: 0;
  }
  .items {
    margin-left: 20px;
    .item {
      margin: 0 20px;
      font-size: 14px;
      color: #1a2e43;
      cursor: pointer;
      &:hover {
        color: #10bb58;
      }
    }
    .item.on {
      font-size: 16px;
      font-weight: bold;
      color: #10bb58;
      position: relative;
      &::after {
        content: "";
        height: 2px;
        background-color: #10bb58;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -5px;
      }
    }
  }
  .search-box {
    width: 200px;
    height: 26px;
    border: 1px solid #d2d2d2;
    border-radius: 50px;
    overflow: hidden;
    .icon {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ipt {
      width: 126px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      input {
        font-size: 13px;
        width: 100%;
        height: 20px;
        margin-right: 3px;
        border: none;
        outline-style: none;
        color: #585858;
      }
    }
    .btn {
      width: 46px;
      background-color: #10bb58;
      color: #fff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      cursor: pointer;
    }
  }
  .login-box {
    margin-left: 20px;
    align-items: center;
    .icon {
      font-size: 0;
    }
    .name {
      font-size: 14px;
      color: #1a2e43;
      margin-left: 5px;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
</style>>
